import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { ButtonHTMLAttributes } from "react";

type FilledButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: "white" | "black" | "gray" | "light-gray" | "primary" | "purple" | "brand" | "transparent";
  text?: string;
  textCase?: "normal" | "uppercase" | "lowercase" | "capitalize";
  borderRadius?: "wide" | "wide-square";
};

export function FilledButton({
  color = "white",
  className,
  children,
  text,
  type = "button",
  textCase = "capitalize",
  borderRadius = "wide",
  ...props
}: FilledButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        textVariants.button,
        "flex h-[50px] w-full items-center justify-center rounded-full bg-white",
        "transition-all duration-200 ease-out disabled:cursor-not-allowed disabled:opacity-60",
        {
          "bg-button-white-default active:bg-button-white-active hover:bg-button-white-active text-black hover:opacity-90 disabled:opacity-50":
            color === "white",
          "bg-button-black-default active:bg-button-black-active hover:bg-button-black-active disabled:bg-button-black-disabled text-white hover:opacity-90 disabled:text-black disabled:opacity-100":
            color === "black",
          "disabled:text-button-black-disabled bg-[#DFDFE0] text-black hover:opacity-80 active:opacity-80":
            color === "gray",
          "bg-gray-50 text-black hover:bg-gray-50 hover:opacity-80 active:bg-gray-50 active:opacity-80":
            color === "light-gray",
          "bg-screen-gs-1 active:bg-screen-gs-1 hover:bg-screen-gs-1 text-white hover:opacity-90 disabled:opacity-50":
            color === "primary",
          "bg-[#513775] active:bg-[#281642] hover:bg-screen-gs-1 text-white hover:opacity-90 disabled:opacity-50":
            color === "purple",
          "bg-os-brand active:bg-os-brand hover:bg-os-brand text-white hover:opacity-90 disabled:opacity-50":
            color === "brand",
          "bg-transparent": color === "transparent",
          "!uppercase": textCase === "uppercase",
          "!lowercase": textCase === "lowercase",
          "!normal-case": textCase === "normal",
          "!capitalize": textCase === "capitalize",
          "rounded-full": borderRadius === "wide",
          "rounded-[14px]": borderRadius === "wide-square",
        },
        className,
      )}
      {...props}
    >
      {text || children}
    </button>
  );
}
